<template>
  <a
    :class="classnames"
    :href="linkTo"
    :rel="rel"
    :target="target"
    @click="handleClick"
  >
    <button-style
      :appearance="appearance"
      :isActive="isActive"
      :isDisabled="isDisabled"
    >
      <span v-if="$slots.text" :class="`${ns}__text`">
        <slot name="text" />
      </span>
      <span v-if="$slots.icon" :class="`${ns}__icon`">
        <slot name="icon" />
      </span>
    </button-style>
  </a>
</template>

<script>
  import ButtonStyle from '@/components/ButtonStyle'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'anchor-button'

  export default {
    name: 'AnchorButton',
    components: {
      'button-style': ButtonStyle
    },
    mixins: [ bem ],
    props: {
      appearance: {
        default: 'default',
        type: String
      },
      isActive: {
        type: Boolean
      },
      isDisabled: {
        type: Boolean
      },
      linkTo: {
        default: '#',
        type: String
      },
      target: {
        default: '_self',
        type: String,
        validator: function (value) {
          return [
            '_self',
            '_blank',
            '_parent',
            '_top'
          ].indexOf(value) !== -1
        }
      }
    },
    data () {
      return {}
    },
    computed: {
      rel: function () {
        let rel = null

        if (this.target === '_blank') {
          rel = 'noopener noreferrer'
        }

        return rel
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleClick () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/AnchorButton.vue